// SPDX-License-Identifier: AGPL-3.0-or-later

// LOCAL-ONLY (favorites-bookmarks-plan.md section 10): a bookmarks list reloads its notes when it opens and on window
// focus while it is open (BookmarkNoteReload.ts: at most once per 15 s). Exclude from upstream sync.

import {reloadNotes} from '@app/features/messaging/commands/BookmarkNoteReload';
import {useEffect} from 'react';

export function useBookmarkNoteReload(open: boolean): void {
	useEffect(() => {
		if (!open) return;
		void reloadNotes();
		const onFocus = () => void reloadNotes();
		window.addEventListener('focus', onFocus);
		return () => window.removeEventListener('focus', onFocus);
	}, [open]);
}
